import { Link } from 'react-router-dom';
import { Button } from '@sandtech-hub-monorepo/ui-kit';
import React from 'react';
import { ReactComponent as UniversityIcon } from '../../assets/Icons/university-icon.svg';

interface Props {
  learningPageLink: string;
}

const SUPPORT_URL = 'https://help.alxafrica.com/support/tickets/new';

export const ProgramsEmptyState = ({ learningPageLink }: Props) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center max-w-2xl mx-auto">
      <div className="p-6 bg-primary/20 rounded-full text-primary mb-6">
        <UniversityIcon height="64" width="64" />
      </div>

      <h2 className="text-2xl font-bold text-foreground mb-3">
        No Programs Available Right Now
      </h2>

      <p className="text-base text-muted-foreground mb-2">
        All programs are currently closed for new enrollments. New opportunities
        will be opening soon!
      </p>

      <p className="text-sm text-muted-foreground mb-8">
        Check back regularly or contact support to be notified when new programs
        become available.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
        <Link to={learningPageLink} className="w-full sm:w-auto">
          <Button variant="default" className="w-full sm:w-auto">
            View My Learning
          </Button>
        </Link>
        <Link
          to={SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full sm:w-auto"
        >
          <Button variant="outline" className="w-full sm:w-auto">
            Contact Support
          </Button>
        </Link>
      </div>
    </div>
  );
};
